import {Injectable, EventEmitter} from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { AgentScriptSettings } from '../../model/agent-script-settings';
import { NewPageCreation } from '../../model/new-page-creation';


@Injectable({ providedIn: 'root' })
export class UtilityService {
    
    modalReference = null;
    private onShowScriptRules: BehaviorSubject<boolean>;
    private onShowAgentScriptPageProperties: BehaviorSubject<boolean>;
    private onShowDialog: BehaviorSubject<boolean>;
    private onShowObjectManagerProperties: BehaviorSubject<boolean>;
    private agentScriptSettings:AgentScriptSettings[] = [];
    private temp:AgentScriptSettings;
    private scriptSettingsObject:AgentScriptSettings;
    private currentAgentScriptId:number;
    private objectId:string;
    private objectList:any;
    private goToPageSaveEvent: EventEmitter<any> = new EventEmitter();
    private hideObjectSaveEmit: EventEmitter<any> = new EventEmitter();
    private selectedGoToPageId:number|string;
    private previewFields:any;
    private showFields:BehaviorSubject<boolean>;
    private newPageCreationObject: NewPageCreation;

    constructor(private modalService: NgbModal) { 
        this.onShowScriptRules = new BehaviorSubject<boolean>(false);
        this.onShowDialog = new BehaviorSubject<boolean>(false);
        this.onShowAgentScriptPageProperties = new BehaviorSubject<boolean>(false);
        this.onShowObjectManagerProperties = new BehaviorSubject<boolean>(false);
        this.showFields = new BehaviorSubject<boolean>(false);
    }

    public setonShowObjectManagerProperties(newValue: boolean): void {
        this.onShowObjectManagerProperties.next(newValue);
    }

    public getonShowObjectManagerProperties(): Observable<boolean> {
        return this.onShowObjectManagerProperties.asObservable();
    }

    public setOnShowScriptRules(newValue: boolean): void {
        this.onShowScriptRules.next(newValue);
    }

    public getOnShowScriptRules(): Observable<boolean> {
        return this.onShowScriptRules.asObservable();
    }
    
    public setOnShowDialog(newValue: boolean): void {
        this.onShowDialog.next(newValue);
    }

    public getOnShowDialog(): Observable<boolean> {
        return this.onShowDialog.asObservable();
    }

    public setOnShowAgentScriptPageProperties(newValue: boolean): void {
        this.onShowAgentScriptPageProperties.next(newValue);
    }

    public getOnShowAgentScriptPageProperties(): Observable<boolean> {
        return this.onShowAgentScriptPageProperties.asObservable();
    }

    open(content, options = {}) {
        this.modalReference = this.modalService.open(content, options).result.then((result) => {
            console.log(`Closed with: ${result}`);
        }, (reason) => {
            console.log(`Dismissed ${this.getDismissReason(reason)}`);
        });
        return this.modalReference;
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

    //Set the tab and page id in Agent Script Settings model format
    public setAgentScriptSettings(tabId:number, pageId:number) {
        const index = this.agentScriptSettings.findIndex(item => item.tabId === tabId);
        this.temp = {
            tabId: tabId,
            pageId: pageId
        };
        if (index !== -1) {
            this.temp.pageId = (pageId === null) ? this.agentScriptSettings[index].pageId : pageId;
            this.agentScriptSettings[index] = this.temp;
        } else {
            this.agentScriptSettings.push(this.temp);
        }
    }

    //Get the Agent Script Settings modal object based on the tab id
    public getAgentScriptSettings(tabId:number) {
        const index = this.agentScriptSettings.findIndex(item => item.tabId === tabId);
        this.scriptSettingsObject = this.agentScriptSettings[index];
        return this.scriptSettingsObject;
    }

    public setObjectList(objectList:any){
        this.objectList = objectList;
    }

    public getObjectList(){
        return this.objectList;
    }

    public setObjectId(objectId:string){
        this.objectId = objectId;
    }

    public getObjectId(){
        return this.objectId;
    }
    
    public setCurrentAgentScriptId(agentScriptId:number) {
        this.currentAgentScriptId = agentScriptId;
    }

    public getCurrentAgentScriptId() {
        return this.currentAgentScriptId;
    }

    public setHideObjectSaveEmit(data){
        this.hideObjectSaveEmit.emit(data);
    }

    public getHideObjectSaveEmit(){
        return this.hideObjectSaveEmit.asObservable();
    }

    public setGoToPageSaveEmit(data) {
        this.goToPageSaveEvent.emit(data);
    }

    public getGoToPageSaveEmit() {
        return this.goToPageSaveEvent.asObservable();
    }

    public setSelectedGoToPageId(goToPageId:number|string) {
        this.selectedGoToPageId = goToPageId;
    }

    public getSelectedGoToPageId() {
        return this.selectedGoToPageId;
    }

    // public async delay(ms: number) {
    //     await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("fired"));
    // }
    public setPreviewFields(fields:any) {
        this.previewFields = fields;
    }

    public getPreviewFields() {
        return this.previewFields;
    }
    public setShowFields(newValue: boolean): void {
        this.showFields.next(newValue);
    }
   
    public getShowFields(): Observable<boolean> {
        return this.showFields.asObservable();
    }

    public setNewPageCreation(pageId = '', pageTitle = '') {
        if (pageId !== '' && pageTitle !== '') {
            let newPage: NewPageCreation = {
                pageId: pageId,
                pageTitle: pageTitle
            }
            this.newPageCreationObject = newPage;
        }
    }

    public getNewPageCreation() {
        return this.newPageCreationObject;
    }
}
